<template>
  <div class="footer text-center title6">
    <div class="mb4">
      Powered By
      <img
        class="footer_image"
        src="../../assets/images/logos/ABACUS_Logo_White.svg"
        alt="abacus white logo"
      />
    </div>
    <div v-if="showSub" class="link1 termandpolicy">
      <router-link to="/termsofservice" class="underlined"
        >Terms of Service</router-link
      >
      and
      <router-link to="/privacypolibies" class="underlined"
        >Privacy Policies</router-link
      >
    </div>
  </div>
</template>

<script lang="ts">

export default {
  props: {
    showSub: {
      type: Boolean,
      default: true
    },
  }
};
</script>

<style scoped>
.footer_image {
  width: 80px;
  margin-top: -0.3rem;
}
.underlined {
  text-decoration: underline;
}
.footer {
  position: relative;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%);
  height: 6rem;
}
@media only screen and (max-width: 900px) {
  .footer {
    width: 100%;
  }
  .underlined {
    font-size: 17px;
    font-weight: 400;
  }
}
</style>
